var map = {
	"./East africa1.gif": 436,
	"./Finnovex-Qatar-Infographics.png": 118,
	"./asset.png": 437,
	"./awardsbackground.jpg": 438,
	"./awardsbackgroundmobile.jpg": 439,
	"./dubai.gif": 440,
	"./ea.gif": 441,
	"./ea1.gif": 442,
	"./finnovex.png": 111,
	"./finnovexdark.png": 59,
	"./ghana.gif": 443,
	"./halfcircleglobe.jpg": 119,
	"./halfcircleglobe.png": 444,
	"./icon.png": 445,
	"./icons/1.png": 120,
	"./icons/10.png": 121,
	"./icons/11.png": 122,
	"./icons/12.png": 123,
	"./icons/13.png": 124,
	"./icons/14.png": 125,
	"./icons/15.png": 126,
	"./icons/16.png": 127,
	"./icons/2.png": 128,
	"./icons/3.png": 129,
	"./icons/4.png": 130,
	"./icons/5.png": 131,
	"./icons/6.png": 132,
	"./icons/7.png": 133,
	"./icons/8.png": 134,
	"./icons/9.png": 135,
	"./johan.gif": 446,
	"./logo/FinnosecMe.png": 136,
	"./logo/Finnovex-Asia-2025.png": 137,
	"./logo/Finnovex-East-Africa-2023.png": 138,
	"./logo/Finnovex-East-Africa-2024.png": 139,
	"./logo/Finnovex-Europe-2024.png": 140,
	"./logo/Finnovex-Middle-East-2023.png": 141,
	"./logo/Finnovex-Middle-East-2024.png": 142,
	"./logo/Finnovex-North-Africa-2024.png": 143,
	"./logo/Finnovex-Qatar-2023.png": 144,
	"./logo/Finnovex-Qatar-2024.png": 145,
	"./logo/Finnovex-Saudi-Arabia-2024.png": 146,
	"./logo/Finnovex-South-Africa-2023.png": 147,
	"./logo/Finnovex-South-Africa-2024.png": 148,
	"./logo/Finnovex-West-Africa-2023.png": 149,
	"./logo/Finnovex-West-Africa-2024 copy 2.png": 150,
	"./logo/Finnovex-West-Africa-2024.png": 151,
	"./logo/awardslogo.png": 60,
	"./logo/ea.png": 152,
	"./logo/eu.png": 153,
	"./logo/exibex.gif": 47,
	"./logo/exibex1.gif": 154,
	"./logo/facebook.png": 155,
	"./logo/finnovex.gif": 156,
	"./logo/footerlogo1.png": 157,
	"./logo/futuristicxme.png": 158,
	"./logo/instagram.png": 159,
	"./logo/linkedin.png": 160,
	"./logo/me.png": 161,
	"./logo/qa.png": 162,
	"./logo/sa.png": 163,
	"./logo/saudi.png": 164,
	"./logo/wa.png": 165,
	"./news/1.jpg": 166,
	"./news/10.jpeg": 167,
	"./news/11.jpeg": 168,
	"./news/12.jpeg": 169,
	"./news/13.jpeg": 170,
	"./news/14.png": 171,
	"./news/15.png": 172,
	"./news/16.png": 173,
	"./news/17.png": 174,
	"./news/18.png": 175,
	"./news/19.png": 176,
	"./news/2.jpg": 177,
	"./news/20.png": 178,
	"./news/21.png": 179,
	"./news/22.png": 180,
	"./news/23.png": 181,
	"./news/24.png": 182,
	"./news/25.png": 183,
	"./news/26.png": 184,
	"./news/27.png": 185,
	"./news/28.png": 186,
	"./news/29.png": 187,
	"./news/3.jpg": 188,
	"./news/30.png": 189,
	"./news/31.png": 190,
	"./news/32.png": 191,
	"./news/4.jpg": 192,
	"./news/5.jpg": 193,
	"./news/6.jpg": 194,
	"./news/7.jpg": 195,
	"./news/8.jpg": 196,
	"./news/9.png": 197,
	"./news/main1.jpg": 61,
	"./news/main10.jpeg": 62,
	"./news/main11.jpeg": 63,
	"./news/main12.jpeg": 64,
	"./news/main13.jpeg": 65,
	"./news/main14.png": 66,
	"./news/main15.png": 67,
	"./news/main16.png": 68,
	"./news/main17.png": 69,
	"./news/main18.png": 70,
	"./news/main19.png": 71,
	"./news/main2.jpg": 72,
	"./news/main20.png": 73,
	"./news/main21.png": 74,
	"./news/main22.png": 75,
	"./news/main23.png": 76,
	"./news/main24.png": 77,
	"./news/main25.png": 78,
	"./news/main26.png": 79,
	"./news/main27.png": 80,
	"./news/main28.png": 81,
	"./news/main29.png": 82,
	"./news/main3.jpg": 83,
	"./news/main30.png": 84,
	"./news/main31.png": 85,
	"./news/main32.png": 86,
	"./news/main4.jpg": 87,
	"./news/main5.jpg": 88,
	"./news/main6.jpg": 89,
	"./news/main7.jpg": 90,
	"./news/main8.jpg": 91,
	"./news/main9.png": 92,
	"./speakers/Antonios.jpg": 198,
	"./speakers/Fidelity.png": 199,
	"./speakers/Musa.jpg": 200,
	"./speakers/SABB.jpeg": 201,
	"./speakers/Thapelo.jpg": 202,
	"./speakers/Varghese.jpg": 203,
	"./speakers/abeed.jpg": 204,
	"./speakers/absa.png": 205,
	"./speakers/adib.jpg": 206,
	"./speakers/axa.png": 207,
	"./speakers/bancABC.jpg": 208,
	"./speakers/brd.png": 209,
	"./speakers/bse.jpg": 210,
	"./speakers/caroline.jpg": 211,
	"./speakers/cbn.jpg": 212,
	"./speakers/citibank.jpg": 213,
	"./speakers/consolidated.jpg": 214,
	"./speakers/dinesh.jpg": 215,
	"./speakers/dtb.png": 216,
	"./speakers/evans.jpg": 217,
	"./speakers/fnb.png": 218,
	"./speakers/fodor.jpg": 219,
	"./speakers/ihab.png": 220,
	"./speakers/james.jpg": 221,
	"./speakers/jenny.jpg": 222,
	"./speakers/lance.jpg": 223,
	"./speakers/luis.jpg": 224,
	"./speakers/mark.jpg": 225,
	"./speakers/menash.png": 226,
	"./speakers/nbe.jpeg": 227,
	"./speakers/ndungu.jpg": 228,
	"./speakers/npc.png": 229,
	"./speakers/pancreta.png": 230,
	"./speakers/radu.jpg": 231,
	"./speakers/sanjay.jpg": 232,
	"./speakers/sberbank.jpg": 233,
	"./speakers/sc.jpg": 234,
	"./speakers/speaker.png": 53,
	"./speakers/stanbic.png": 235,
	"./speakers/zerak.jpg": 236,
	"./speakers1/BAK.png": 447,
	"./speakers1/Barclays.png": 448,
	"./speakers1/Bonaventure.jpg": 449,
	"./speakers1/Chresta.jpg": 450,
	"./speakers1/Daniel.jpg": 451,
	"./speakers1/Ecobank.png": 452,
	"./speakers1/Equity.png": 453,
	"./speakers1/Erdal.jpg": 454,
	"./speakers1/FinnoSec Africa-Design Updates.docx": 455,
	"./speakers1/FirstBank.png": 456,
	"./speakers1/HABITAT.png": 457,
	"./speakers1/Harrison.jpg": 458,
	"./speakers1/ISACA.jpg": 459,
	"./speakers1/KENYA.png": 460,
	"./speakers1/KRA.png": 461,
	"./speakers1/Lanre.png": 462,
	"./speakers1/MG.png": 463,
	"./speakers1/MIGORI.png": 464,
	"./speakers1/NTSA.png": 465,
	"./speakers1/Peter.jpg": 466,
	"./speakers1/RI.png": 467,
	"./speakers1/SC.png": 468,
	"./speakers1/SOCIETE.png": 469,
	"./speakers1/Steve.jpg": 470,
	"./speakers1/UAP.png": 471,
	"./speakers1/UASIN.jpg": 472,
	"./speakers1/UBE.jpg": 473,
	"./speakers1/Unity.png": 474,
	"./speakers1/aijaz.jpg": 475,
	"./speakers1/cbok.png": 476,
	"./speakers1/christian.jpg": 477,
	"./speakers1/hartnell.jpg": 478,
	"./speakers1/imb.png": 479,
	"./speakers1/koroty.png": 480,
	"./speakers1/melaku.png": 481,
	"./speakers1/raymond.jpg": 482,
	"./speakers1/speaker.png": 483,
	"./speakers1/stanley.jpg": 484,
	"./speakers1/stephane.jpg": 485,
	"./speakers1/test.jpg": 486,
	"./speakers1/thomas.jpg": 487,
	"./speakers2/Abdulla.jpeg": 488,
	"./speakers2/Abdulmohsen.jpeg": 489,
	"./speakers2/Ahmed.jpeg": 490,
	"./speakers2/Alaeddin.jpeg": 491,
	"./speakers2/Alomran.jpeg": 492,
	"./speakers2/Amit.jpeg": 493,
	"./speakers2/Amol.jpeg": 494,
	"./speakers2/Andreas.jpeg": 495,
	"./speakers2/Arjun.png": 496,
	"./speakers2/Azra.jpeg": 497,
	"./speakers2/Biswajit.jpeg": 498,
	"./speakers2/Dena.jpeg": 499,
	"./speakers2/Evans.jpeg": 500,
	"./speakers2/Fahd.jpeg": 501,
	"./speakers2/Farshad.jpeg": 502,
	"./speakers2/Frederik.jpeg": 503,
	"./speakers2/Ghinwa.jpeg": 504,
	"./speakers2/Helen.jpg": 505,
	"./speakers2/Jayesh.jpeg": 506,
	"./speakers2/Jessica.jpeg": 507,
	"./speakers2/Johnson.jpeg": 508,
	"./speakers2/Mirna.jpeg": 509,
	"./speakers2/Mohamed.jpeg": 510,
	"./speakers2/Muhannad.jpeg": 511,
	"./speakers2/Mustafa.jpeg": 512,
	"./speakers2/Nameer.jpeg": 513,
	"./speakers2/Omar.jpeg": 514,
	"./speakers2/Osama.jpeg": 515,
	"./speakers2/Peter.jpeg": 516,
	"./speakers2/Philip.jpeg": 517,
	"./speakers2/Prem.jpeg": 518,
	"./speakers2/Pritesh.jpeg": 519,
	"./speakers2/Raja.jpeg": 520,
	"./speakers2/Reji.jpeg": 521,
	"./speakers2/Roland.jpeg": 522,
	"./speakers2/Ronit.jpeg": 523,
	"./speakers2/Sagheer.jpeg": 524,
	"./speakers2/Sandeep.jpeg": 525,
	"./speakers2/Sanjay.jpeg": 526,
	"./speakers2/Saqib.jpeg": 527,
	"./speakers2/Sonia.jpeg": 528,
	"./speakers2/Sonny.jpeg": 529,
	"./speakers2/Tomasz.jpeg": 530,
	"./speakers2/Wesam.jpeg": 531,
	"./speakers2/abdullah.jpeg": 532,
	"./speakers2/charbel.jpeg": 533,
	"./speakers2/gautam.jpeg": 534,
	"./speakers2/lukasz.jpeg": 535,
	"./speakers2/mahmoud.jpeg": 536,
	"./speakers2/massimo.jpeg": 537,
	"./speakers2/micky.jpeg": 538,
	"./speakers2/profile.jpeg": 539,
	"./speakers2/rohit.jpeg": 540,
	"./speakers2/roshdy.jpeg": 541,
	"./speakers2/steve.jpeg": 542,
	"./sponsor/72ppi/Asset 43.png": 237,
	"./sponsor/72ppi/Asset 44.png": 238,
	"./sponsor/72ppi/Asset 45.png": 239,
	"./sponsor/72ppi/abaka.png": 240,
	"./sponsor/72ppi/afn.png": 241,
	"./sponsor/72ppi/arabnet.png": 242,
	"./sponsor/72ppi/avaya.png": 243,
	"./sponsor/72ppi/backbase.png": 244,
	"./sponsor/72ppi/banserv.png": 245,
	"./sponsor/72ppi/blockchain.png": 246,
	"./sponsor/72ppi/caia.png": 247,
	"./sponsor/72ppi/cbon.png": 248,
	"./sponsor/72ppi/coforge.png": 249,
	"./sponsor/72ppi/comviva.png": 250,
	"./sponsor/72ppi/consdata.png": 251,
	"./sponsor/72ppi/daon.png": 252,
	"./sponsor/72ppi/difc.png": 253,
	"./sponsor/72ppi/expo2020.png": 254,
	"./sponsor/72ppi/fintechgalaxy.png": 255,
	"./sponsor/72ppi/fss.png": 256,
	"./sponsor/72ppi/hyperpay.png": 257,
	"./sponsor/72ppi/iib.png": 258,
	"./sponsor/72ppi/infasoft.png": 259,
	"./sponsor/72ppi/infobip.png": 260,
	"./sponsor/72ppi/minafintech.png": 261,
	"./sponsor/72ppi/neosoft.png": 262,
	"./sponsor/72ppi/netcore.png": 263,
	"./sponsor/72ppi/newgen.png": 264,
	"./sponsor/72ppi/onespan.png": 265,
	"./sponsor/72ppi/openfactor.png": 266,
	"./sponsor/72ppi/oracle.png": 267,
	"./sponsor/72ppi/payoneer.png": 268,
	"./sponsor/72ppi/piotech.png": 269,
	"./sponsor/72ppi/pwc.png": 270,
	"./sponsor/72ppi/rubrik.png": 271,
	"./sponsor/72ppi/scventures.png": 272,
	"./sponsor/72ppi/simba.png": 273,
	"./sponsor/72ppi/smartstream.png": 274,
	"./sponsor/72ppi/tcs.png": 275,
	"./sponsor/72ppi/temenos.png": 276,
	"./sponsor/72ppi/tripwire.png": 277,
	"./sponsor/72ppi/turbonomic.png": 278,
	"./sponsor/72ppi/vacuumlabs.png": 279,
	"./sponsor/72ppi/yethi.png": 280,
	"./sponsor/NewsAffinity.jpeg": 281,
	"./sponsor/Sponsor Logos.ai": 282,
	"./sponsor/abaka.jpeg": 283,
	"./sponsor/afn.jpeg": 284,
	"./sponsor/appway.png": 285,
	"./sponsor/arabnet.jpeg": 286,
	"./sponsor/aroundb.png": 287,
	"./sponsor/avaya.jpeg": 288,
	"./sponsor/backbase.jpeg": 289,
	"./sponsor/backbase.png": 290,
	"./sponsor/bankserv.jpeg": 291,
	"./sponsor/beincrypto.jpeg": 292,
	"./sponsor/blockchain.jpeg": 293,
	"./sponsor/brussels.png": 294,
	"./sponsor/caia.jpeg": 295,
	"./sponsor/cbon.jpeg": 296,
	"./sponsor/coforge.jpeg": 297,
	"./sponsor/coinmercury.jpeg": 298,
	"./sponsor/coinquora.png": 299,
	"./sponsor/coinrepublic.png": 300,
	"./sponsor/comarch.jpeg": 301,
	"./sponsor/comviva.jpeg": 302,
	"./sponsor/confluent.jpg": 303,
	"./sponsor/consdata.jpeg": 304,
	"./sponsor/creatio.png": 305,
	"./sponsor/cryptonewz.jpeg": 306,
	"./sponsor/ct.jpeg": 307,
	"./sponsor/daon.jpeg": 308,
	"./sponsor/difc.jpeg": 309,
	"./sponsor/digitalscouting.png": 310,
	"./sponsor/edb.jpeg": 311,
	"./sponsor/ema.png": 312,
	"./sponsor/eppan.jpeg": 313,
	"./sponsor/expo2020.jpeg": 314,
	"./sponsor/faloos.jpg": 315,
	"./sponsor/financialit.jpeg": 316,
	"./sponsor/financialnigeria.png": 317,
	"./sponsor/find.jpeg": 318,
	"./sponsor/fintechfutures.jpeg": 319,
	"./sponsor/fintechgalaxy.jpeg": 320,
	"./sponsor/fintechna.jpeg": 321,
	"./sponsor/fintechnews.png": 322,
	"./sponsor/fintechpower.jpeg": 323,
	"./sponsor/fintechtimes.jpeg": 324,
	"./sponsor/freshworks.png": 325,
	"./sponsor/fss.jpeg": 326,
	"./sponsor/holland.png": 327,
	"./sponsor/hyperpay.jpeg": 328,
	"./sponsor/ibm.jpeg": 329,
	"./sponsor/ids.png": 330,
	"./sponsor/ie.jpg": 331,
	"./sponsor/igologic.jpg": 332,
	"./sponsor/iib.jpeg": 333,
	"./sponsor/infobip.jpeg": 334,
	"./sponsor/infrasoft.jpeg": 335,
	"./sponsor/innovationtech.png": 336,
	"./sponsor/koinpost.png": 337,
	"./sponsor/kriptomeda.jpg": 338,
	"./sponsor/listing.png": 339,
	"./sponsor/microsoft.png": 340,
	"./sponsor/minafintech.jpeg": 341,
	"./sponsor/mobile.jpeg": 342,
	"./sponsor/neosoft.jpeg": 343,
	"./sponsor/netcore.jpeg": 344,
	"./sponsor/network.jpg": 345,
	"./sponsor/newgen.jpeg": 346,
	"./sponsor/onespan.jpeg": 347,
	"./sponsor/openfactor.jpeg": 348,
	"./sponsor/oracle.jpeg": 349,
	"./sponsor/oxford.jpeg": 350,
	"./sponsor/payoneer.jpeg": 351,
	"./sponsor/paypers.jpg": 352,
	"./sponsor/pcn.png": 353,
	"./sponsor/piotech.jpeg": 354,
	"./sponsor/pwc.jpeg": 355,
	"./sponsor/rakbank.png": 356,
	"./sponsor/regtech.png": 357,
	"./sponsor/residentialtech.png": 358,
	"./sponsor/rubrik.jpeg": 359,
	"./sponsor/scventures.jpeg": 360,
	"./sponsor/security.png": 361,
	"./sponsor/sfa.jpg": 362,
	"./sponsor/silicon.jpeg": 363,
	"./sponsor/simba.jpeg": 364,
	"./sponsor/sinofy.png": 365,
	"./sponsor/skiply.png": 366,
	"./sponsor/smart.png": 367,
	"./sponsor/smartmessage.png": 368,
	"./sponsor/smartstream.jpeg": 369,
	"./sponsor/smartstream.png": 370,
	"./sponsor/sme.jpg": 371,
	"./sponsor/startupnews.png": 372,
	"./sponsor/sybrin.png": 373,
	"./sponsor/tcs.jpeg": 374,
	"./sponsor/temenos.jpeg": 375,
	"./sponsor/tripwire.jpeg": 376,
	"./sponsor/turbonomic.jpeg": 377,
	"./sponsor/ufg.png": 378,
	"./sponsor/vacuumlabs.jpeg": 379,
	"./sponsor/yethi.jpeg": 380,
	"./sponsor/yourTraget.png": 381,
	"./sponsor/zentity.png": 382,
	"./sponsor1/Ambidextr.png": 543,
	"./sponsor1/Coinsdataflow.jpeg": 544,
	"./sponsor1/Cointelegraph.jpeg": 545,
	"./sponsor1/FinancialIT.jpeg": 546,
	"./sponsor1/Kitamo.png": 547,
	"./sponsor1/NewsAffinity.jpeg": 548,
	"./sponsor1/NewsAffinity.png": 549,
	"./sponsor1/PaymentsAfrika.png": 550,
	"./sponsor1/TEMENOS.png": 551,
	"./sponsor1/TP.png": 552,
	"./sponsor1/africa.jpeg": 553,
	"./sponsor1/baa.png": 554,
	"./sponsor1/backbase.png": 555,
	"./sponsor1/bankserv.jpg": 556,
	"./sponsor1/bigdata.jpeg": 557,
	"./sponsor1/blocksocial.png": 558,
	"./sponsor1/cbon.png": 559,
	"./sponsor1/cexio.jpg": 560,
	"./sponsor1/coinsflare.png": 561,
	"./sponsor1/consdata.png": 562,
	"./sponsor1/daon.jpg": 563,
	"./sponsor1/edb.png": 564,
	"./sponsor1/expo2020.png": 565,
	"./sponsor1/findbiometrics.jpeg": 566,
	"./sponsor1/fintechfutures.jpeg": 567,
	"./sponsor1/fintechpower.jpeg": 568,
	"./sponsor1/fintechtimes.jpeg": 569,
	"./sponsor1/ibm.jpeg": 570,
	"./sponsor1/mobileidworld.jpeg": 571,
	"./sponsor1/onespan.jpg": 572,
	"./sponsor1/oracle.jpg": 573,
	"./sponsor1/privatebanking.jpeg": 574,
	"./sponsor1/pwc.jpg": 575,
	"./sponsor1/rubrik.jpg": 576,
	"./sponsor1/scventure.jpg": 577,
	"./sponsor1/tcs.jpg": 578,
	"./sponsors/Ambidextr.png": 579,
	"./sponsors/Coinsdataflow.jpeg": 580,
	"./sponsors/Cointelegraph.jpeg": 581,
	"./sponsors/EY.jpeg": 582,
	"./sponsors/FinancialIT.jpeg": 583,
	"./sponsors/Kitamo.png": 584,
	"./sponsors/NIIT.jpeg": 585,
	"./sponsors/NewsAffinity.jpeg": 586,
	"./sponsors/NewsAffinity.png": 587,
	"./sponsors/PaymentsAfrika.png": 588,
	"./sponsors/Payoneer.jpeg": 589,
	"./sponsors/TEMENOS.png": 590,
	"./sponsors/TP.png": 591,
	"./sponsors/Watermelon.jpeg": 592,
	"./sponsors/abaka.jpg": 593,
	"./sponsors/africa.jpeg": 594,
	"./sponsors/ambidextr.jpeg": 595,
	"./sponsors/amm.png": 596,
	"./sponsors/arabnet.jpeg": 597,
	"./sponsors/assertify.png": 598,
	"./sponsors/avaya.png": 599,
	"./sponsors/baa.png": 600,
	"./sponsors/backbase.jpeg": 601,
	"./sponsors/backbase.png": 602,
	"./sponsors/bankingcio.jpeg": 603,
	"./sponsors/bankserv.jpg": 604,
	"./sponsors/bc.jpeg": 605,
	"./sponsors/bigdata.jpeg": 606,
	"./sponsors/blocksocial.jpeg": 607,
	"./sponsors/blocksocial.png": 608,
	"./sponsors/caia.jpeg": 609,
	"./sponsors/cbon.png": 610,
	"./sponsors/cexio.jpg": 611,
	"./sponsors/cibe.jpeg": 612,
	"./sponsors/coinsflare.jpeg": 613,
	"./sponsors/coinsflare.png": 614,
	"./sponsors/comarch.jpeg": 615,
	"./sponsors/comviva.png": 616,
	"./sponsors/confluent.jpg": 617,
	"./sponsors/consdata.jpeg": 618,
	"./sponsors/consdata.png": 619,
	"./sponsors/creatio.png": 620,
	"./sponsors/cryptonewz.jpeg": 621,
	"./sponsors/daon.jpg": 622,
	"./sponsors/edb.png": 623,
	"./sponsors/ema.png": 624,
	"./sponsors/eppan.png": 625,
	"./sponsors/expo.jpeg": 626,
	"./sponsors/expo2020.png": 627,
	"./sponsors/findbiometrics.jpeg": 628,
	"./sponsors/fintech.jpeg": 629,
	"./sponsors/fintechfinance.jpeg": 630,
	"./sponsors/fintechfutures.jpeg": 631,
	"./sponsors/fintechgalaxy.jpeg": 632,
	"./sponsors/fintechna.png": 633,
	"./sponsors/fintechnetwork.png": 634,
	"./sponsors/fintechpower.jpeg": 635,
	"./sponsors/fintechtimes.jpeg": 636,
	"./sponsors/fss.png": 637,
	"./sponsors/hyperpay.jpeg": 638,
	"./sponsors/ibm.jpeg": 639,
	"./sponsors/iib.jpeg": 640,
	"./sponsors/infobip.jpeg": 641,
	"./sponsors/infrasoft.png": 642,
	"./sponsors/investera.jpeg": 643,
	"./sponsors/isaca.png": 644,
	"./sponsors/kitamo.jpeg": 645,
	"./sponsors/kriptomeda.jpg": 646,
	"./sponsors/maxut.png": 647,
	"./sponsors/menafintech.jpeg": 648,
	"./sponsors/microsoft.png": 649,
	"./sponsors/mobileidworld.jpeg": 650,
	"./sponsors/netcore.png": 651,
	"./sponsors/network.jpg": 652,
	"./sponsors/newgen.png": 653,
	"./sponsors/onespan.jpeg": 654,
	"./sponsors/onespan.jpg": 655,
	"./sponsors/openfactor.png": 656,
	"./sponsors/oracle.jpeg": 657,
	"./sponsors/oracle.jpg": 658,
	"./sponsors/oxford.png": 659,
	"./sponsors/pcn.png": 660,
	"./sponsors/piotech.png": 661,
	"./sponsors/privatebanking.jpeg": 662,
	"./sponsors/pwc.jpeg": 663,
	"./sponsors/pwc.jpg": 664,
	"./sponsors/rubrik.jpg": 665,
	"./sponsors/scventure.jpg": 666,
	"./sponsors/smartstream.jpeg": 667,
	"./sponsors/smartstream.png": 668,
	"./sponsors/tata.jpeg": 669,
	"./sponsors/tcs.jpg": 670,
	"./sponsors/telco.jpeg": 671,
	"./sponsors/tripwire.jpeg": 672,
	"./sponsors/truebanking.jpeg": 673,
	"./sponsors/turbonomic.png": 674,
	"./sponsors/yethi.png": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;